import { Repository, EntityRepository } from 'typeorm';
import { TrimsMapping } from '../trims-configuration.entity';


@EntityRepository(TrimsMapping)
export class TrimsMappingRepository extends Repository<TrimsMapping>{

    /**
     *
     * @param PurchaseOrderId the po id
     */
    

    
}
